export function isUrlAsExpected(originalUrl: string, locationUrl: string): boolean {
    const originalUrlObject = new URL(originalUrl.toLowerCase());
    const locationUrlObject = new URL(locationUrl.toLowerCase());
    originalUrlObject.pathname = decodeURI(originalUrlObject.pathname.endsWith('/') ? originalUrlObject.pathname.slice(0, -1) : originalUrlObject.pathname);
    locationUrlObject.pathname = decodeURI(locationUrlObject.pathname.endsWith('/') ? locationUrlObject.pathname.slice(0, -1) : locationUrlObject.pathname);
    const isEqual = originalUrlObject.pathname === locationUrlObject.pathname;
    return isEqual;
}
